import { gql } from "@apollo/client";

const GET_FACTSHEET_PDF = gql`
    query factsheetPdf($heiID: String!) {
        factsheetPdf(heiID: $heiID )
    }
`;

export default GET_FACTSHEET_PDF;
